export default "__VITE_ASSET__DAm$5fEe__"